import { IntlFormatters } from "react-intl";
import defineMessages from "../defineMessages";

export const countryMessages = defineMessages({
    England: {
        id: "country.England",
    },
    Austria: {
        id: "country.Austria",
    },
    Czech: {
        id: "country.Czech",
    },
    Finland: {
        id: "country.Finland",
    },
    France: {
        id: "country.France",
    },
    Greece: {
        id: "country.Greece",
    },
    Georgia: {
        id: "country.Georgia",
    },
    Hungary: {
        id: "country.Hungary",
    },
    Netherlands: {
        id: "country.Netherlands",
    },
    Indonesia: {
        id: "country.Indonesia",
    },
    Ireland: {
        id: "country.Ireland",
    },
    Iceland: {
        id: "country.Iceland",
    },
    Japan: {
        id: "country.Japan",
    },
    China: {
        id: "country.China",
    },
    Poland: {
        id: "country.Poland",
    },
    Latvia: {
        id: "country.Latvia",
    },
    Germany: {
        id: "country.Germany",
    },
    Norway: {
        id: "country.Norway",
    },
    Italy: {
        id: "country.Italy",
    },
    Russia: {
        id: "country.Russia",
    },
    Armenia: {
        id: "country.Armenia",
    },
    Portugal: {
        id: "country.Portugal",
    },
    Romania: {
        id: "country.Romania",
    },
    Scotland: {
        id: "country.Scotland",
    },
    Spain: {
        id: "country.Spain",
    },
    Sweden: {
        id: "country.Sweden",
    },
    Serbia: {
        id: "country.Serbia",
    },
    Slovakia: {
        id: "country.Slovakia",
    },
    Slovenia: {
        id: "country.Slovenia",
    },
    Ukraine: {
        id: "country.Ukraine",
    },
    USA: {
        id: "country.USA",
    },
    Estonia: {
        id: "country.Estonia",
    },
    Belarus: {
        id: "country.Belarus",
    },
    Bulgaria: {
        id: "country.Bulgaria",
    },
    Lithuania: {
        id: "country.Lithuania",
    },
    Croatia: {
        id: "country.Croatia",
    },
    Denmark: {
        id: "country.Denmark",
    },
    Switzerland: {
        id: "country.Switzerland",
    },
    Belgium: {
        id: "country.Belgium",
    },
    Turkey: {
        id: "country.Turkey",
    },
    Cyprus: {
        id: "country.Cyprus",
    },
});

export const countries = (fm: IntlFormatters["formatMessage"]) => {
    return [
        { value: "England", code: "gb", label: fm(countryMessages.England) },
        { value: "Austria", code: "at", label: fm(countryMessages.Austria) },
        { value: "Czech", code: "cz", label: fm(countryMessages.Czech) },
        { value: "Finland", code: "fi", label: fm(countryMessages.Finland) },
        { value: "France", code: "fr", label: fm(countryMessages.France) },
        { value: "Greece", code: "gr", label: fm(countryMessages.Greece) },
        { value: "Georgia", code: "ge", label: fm(countryMessages.Georgia) },
        { value: "Hungary", code: "hu", label: fm(countryMessages.Hungary) },
        { value: "Netherlands", code: "nl", label: fm(countryMessages.Netherlands) },
        { value: "Indonesia", code: "id", label: fm(countryMessages.Indonesia) },
        { value: "Ireland", code: "ie", label: fm(countryMessages.Ireland) },
        { value: "Iceland", code: "is", label: fm(countryMessages.Iceland) },
        { value: "Japan", code: "jp", label: fm(countryMessages.Japan) },
        { value: "China", code: "cn", label: fm(countryMessages.China) },
        { value: "Poland", code: "pl", label: fm(countryMessages.Poland) },
        { value: "Latvia", code: "lv", label: fm(countryMessages.Latvia) },
        { value: "Germany", code: "de", label: fm(countryMessages.Germany) },
        { value: "Norway", code: "no", label: fm(countryMessages.Norway) },
        { value: "Italy", code: "it", label: fm(countryMessages.Italy) },
        { value: "Russia", code: "ru", label: fm(countryMessages.Russia) },
        { value: "Armenia", code: "am", label: fm(countryMessages.Armenia) },
        { value: "Portugal", code: "pt", label: fm(countryMessages.Portugal) },
        { value: "Romania", code: "ro", label: fm(countryMessages.Romania) },
        { value: "Spain", code: "es", label: fm(countryMessages.Spain) },
        { value: "Sweden", code: "se", label: fm(countryMessages.Sweden) },
        { value: "Serbia", code: "rs", label: fm(countryMessages.Serbia) },
        { value: "Slovakia", code: "sk", label: fm(countryMessages.Slovakia) },
        { value: "Slovenia", code: "si", label: fm(countryMessages.Slovenia) },
        { value: "Ukraine", code: "ua", label: fm(countryMessages.Ukraine) },
        { value: "USA", code: "us", label: fm(countryMessages.USA) },

        { value: "Estonia", code: "et", label: fm(countryMessages.Estonia) },
        { value: "Belarus", code: "by", label: fm(countryMessages.Belarus) },
        { value: "Bulgaria", code: "bg", label: fm(countryMessages.Bulgaria) },
        { value: "Lithuania", code: "lt", label: fm(countryMessages.Lithuania) },
        { value: "Croatia", code: "hr", label: fm(countryMessages.Croatia) },
        { value: "Denmark", code: "dk", label: fm(countryMessages.Denmark) },
        { value: "Switzerland", code: "ch", label: fm(countryMessages.Switzerland) },
        { value: "Belgium", code: "be", label: fm(countryMessages.Belgium) },
        { value: "Turkey", code: "tr", label: fm(countryMessages.Turkey) },
        { value: "Cyprus", code: "cy", label: fm(countryMessages.Cyprus) },
    ];
};